import {
  BodyText,
  Button,
  ButtonType,
  HeadlineTitle,
  ParagraphTitle,
  Span,
} from 'modules/ui';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'modules/hooks/appHooks';
import { useToastContainer } from 'modules/layout/toastContainer';
import { LeasingCalculatorThunks } from 'modules/leasingCalculator/redux';
import { LeasingCalculatorPathsEnum } from 'modules/leasingCalculator/routes';
import { ToastType } from 'modules/ui/toast';
import backgroundImage from './res/landing-background.jpg';
import {
  StyledBottomContainer,
  StyledButtonContainer,
  StyledCalculatorContainer,
  StyledLandingPageContentContainer,
  StyledMiddleContainer,
  StyledTitle,
  StyledTopContainer,
} from './styled';
import {useTheme} from "styled-components";

export const LandingPage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { addToast } = useToastContainer();
  const theme = useTheme() as any;

  const onCalculatorStart = async () => {
    const result = await dispatch(
      LeasingCalculatorThunks.startLeasingCalculator(),
    );

    if (result.payload === true) {
      history.push(LeasingCalculatorPathsEnum.leasingCalculator);
    } else {
      addToast({
        type: ToastType.Urgent,
        title: t('leasingCalculator.notAvailableErrorTitle'),
        text: t('leasingCalculator.notAvailableErrorMessage'),
      });
    }
  };

  return (
    <StyledLandingPageContentContainer
      className="full-width-container"
      backgroundImage={backgroundImage}>
      <StyledTopContainer>
        <StyledTitle>
          <Trans
            i18nKey="landingPage.title"
            components={{
              highlight: <Span color={theme.colors.primaryR1} />,
              upperCase: <Span textTransform="uppercase" />,
            }}
          />
        </StyledTitle>
      </StyledTopContainer>

      <StyledMiddleContainer>
        <HeadlineTitle>{t('landingPage.headlineTitle')}</HeadlineTitle>
        <BodyText>{t('landingPage.descriptionText')}</BodyText>
        <ul>
          <li>
            <BodyText>{t('landingPage.contractsOverviewDetailsText')}</BodyText>
          </li>
          <li>
            <BodyText>{t('landingPage.billsDetailsText')}</BodyText>
          </li>
          <li>
            <BodyText>{t('landingPage.infoCalculatorText')}</BodyText>
          </li>
          <li>
            <BodyText>{t('landingPage.documentsText')}</BodyText>
          </li>
        </ul>
      </StyledMiddleContainer>

      <StyledBottomContainer>
        <StyledCalculatorContainer>
          <ParagraphTitle style={{ display: 'inline-block' }}>{t('landingPage.subtitle')}</ParagraphTitle>
          <br/>
          <BodyText style={{ display: 'inline-block' }}>{t('landingPage.instructionText')}</BodyText>
          <StyledButtonContainer>
            <Button
              text={t('landingPage.startCalculator')}
              type={ButtonType.Primary}
              onClick={onCalculatorStart}
              ariaLabel={"Pokreni kalkulator"}
            />
            {/* FRON-669 commented for release day
            <Button
              text={t('landingPage.register')}
              type={ButtonType.Secondary}
              onClick={() => history.push('/register')}
              color={theme.colors.primaryW}
              hoverColor={theme.colors.primaryK3}
            />
          */}
          </StyledButtonContainer>
        </StyledCalculatorContainer>
      </StyledBottomContainer>
    </StyledLandingPageContentContainer>
  );
};
